import {Dispatcher} from 'flux'

export default new Dispatcher()



// WEBPACK FOOTER //
// lib/AppDispatcher.js